import TitleDisplay from "./TitleDisplay";
interface Props {
  title: string;
  address: string;
  owners: [];
}

type TitelDisplayProps = {
  mainTitle: string;
  addressText: string;
  owners: [];
}

const Title = ({ title, address, owners }: Props) => {

  let addressText: string = '';

  if(address) {
    addressText = address;
  }


  const getDisplayTitle = (title?: string, address?: { firstLine?: string } | string): string => {
    return title  ?? 'Shop to rent';
  };

  let mainTitle = getDisplayTitle(title, address);

  const props: TitelDisplayProps = {
    addressText,
    mainTitle,
    owners
  }

  return (
    <TitleDisplay {...props} />
  );
};

export default Title;
